<template>
  <!-- container -->
  <div class="container mb-4 p-sm-3">
    <div class="mb-3 sm-1" v-if="notReported">
      <h2 class="lead d-inline-block mt-2 mr-2">新規申請の前に、開催報告を済ませましょう</h2>
    </div>
    <section id="event-list" class="mb-3">
      <div class="row">
        <list-item v-for="(item, index) in notReportedItems"
        :item="item" :index="index"
        :key="item.id"
        :canApply="canApply"
        />
      </div>
    </section>

    <div class="mb-3 sm-1">
      <div class="row" v-if="canApply">
        <h2 class="lead d-inline-block mt-2 mr-2">撮影会／イベント／教室一覧</h2>
        <a href="/lecturer/input" class="text-white btn btn-new" @click.prevent="onMoveToInput()">新規作成</a>
      </div>
      <div class="row" v-else>
        <h2 class="lead d-inline-block mt-2 mr-2">その他の申請</h2>
      </div>
    </div>

  <div class="event-serch card">
    <div class="card-header" role="tab" id="headingOne">
      <h5 class="mb-0">
        <a data-toggle="collapse" href="#search-collapse" aria-expanded="false" aria-controls="collapseOne">検索条件入力</a>
      </h5>
    </div>
    <div id="search-collapse" class="collapse" role="tabpanel" aria-labelledby="headingOne">
      <div class="card-block">
        <div class="form-group row">
          <label for="search-lecturer-name" class="col-12 col-lg-2 col-form-label">掲載終了日</label>
          <div class="col-12 col-lg-4">
            <input class="form-control" type="text" value="" id="search-enddate-from" placeholder="2017/01/01" v-model="query.enddate_from">
            <p class="error-msg" v-if="isEndDateFromFormatInValid">YYYY/MM/DDの形式で入力してください</p>
            <p class="error-msg" v-if="isEndDateFromInValid">日付を確認してください</p>
          </div>
          <p class="col-12 col-lg-1">〜</p>
          <div class="col-12 col-lg-4">
            <input class="form-control" type="text" value="" id="search-enddate-to" placeholder="2017/01/01" v-model="query.enddate_to">
            <p class="error-msg" v-if="isEndDateInValid">検索開始日より新しい日付を入力して下さい</p>
            <p class="error-msg" v-if="isEndDateToFormatInValid">YYYY/MM/DDの形式で入力してください</p>
            <p class="error-msg" v-if="isEndDateToInValid">日付を確認してください</p>
          </div>
        </div>
        <div class="form-group row">
          <label for="search-status" class="col-12 col-lg-2 col-form-label">ステータス</label>
          <div class="col-12 col-lg-4">
            <select class="form-control" id="search-status" v-model="query.status">
              <option value="all">選択して下さい</option>
              <option v-for="key in Object.keys(eventStatusText)"
              :value="key">{{ eventStatusText[key] }}</option>
            </select>
          </div>
        </div>
        <div class="form-group row">
          <label for="search-area" class="col-12 col-lg-2 col-form-label">地域</label>
          <div class="col-12 col-lg-4">
            <select class="form-control" id="search-area" v-model="query.area" ref="area"> 
              <option value="">選択して下さい</option>
              <option>北海道</option>
              <option>東北</option>
              <option>関東</option>
              <option>中部</option>
              <option>近畿</option>
              <option>中国</option>
              <option>四国</option>
              <option>九州</option>
              <option>沖縄</option>
            </select>
          </div>
        </div>
        <div class="form-group row">
          <label for="search-prefecture" class="col-12 col-lg-2 col-form-label">都道府県</label>
          <div class="col-12 col-lg-4">
            <select class="form-control" id="search-prefecture" v-model="query.prefecture" ref="prefecture"> 
              <option value="">選択して下さい</option>
              <option>北海道</option>
              <option>青森県</option>
              <option>岩手県</option>
              <option>宮城県</option>
              <option>秋田県</option>
              <option>山形県</option>
              <option>福島県</option>
              <option>茨城県</option>
              <option>栃木県</option>
              <option>群馬県</option>
              <option>埼玉県</option>
              <option>千葉県</option>
              <option>東京都</option>
              <option>神奈川県</option>
              <option>山梨県</option>
              <option>新潟県</option>
              <option>富山県</option>
              <option>石川県</option>
              <option>福井県</option>
              <option>長野県</option>
              <option>岐阜県</option>
              <option>静岡県</option>
              <option>愛知県</option>
              <option>三重県</option>
              <option>滋賀県</option>
              <option>京都府</option>
              <option>大阪府</option>
              <option>兵庫県</option>
              <option>奈良県</option>
              <option>和歌山県</option>
              <option>鳥取県</option>
              <option>島根県</option>
              <option>岡山県</option>
              <option>広島県</option>
              <option>山口県</option>
              <option>徳島県</option>
              <option>香川県</option>
              <option>愛媛県</option>
              <option>高知県</option>
              <option>福岡県</option>
              <option>佐賀県</option>
              <option>長崎県</option>
              <option>熊本県</option>
              <option>大分県</option>
              <option>宮崎県</option>
              <option>鹿児島県</option>
              <option>沖縄県</option>
            </select>
          </div>
          <p class="col-12 col-lg-6 small">※ 地域と同時に入力することは出来ません。</p>
        </div>

        <div class="form-group row">
          <label for="search-sponsor" class="col-12 col-lg-2 col-form-label">主催者</label>
          <div class="col-12 col-lg-4">
            <input class="form-control" type="text" value="" id="search-sponsor" v-model="query.sponsor_name">
          </div>
        </div>

        <button type="submit" class="btn btn-primary offset-lg-2" :class="searchStyle" @click.prevent="search">検索</button>
      </div>
    </div>
  </div>

    <p class="col-12">※承認依頼済みのイベントを変更する場合は、詳細画面から承認依頼の取り消しを行ってください。</p>

    <section id="event-list">
      <div class="row">
        <list-item v-for="(item, index) in items"
        :item="item" :index="index"
        :key="item.id"
        :canApply="canApply"
        @showErrorModal="$emit('showErrorModal', $event)"
        />
      </div>
    </section>

    <page-nav :current="currentPage" :max="maxPage"
     @onPageSelected="onMoveToPage($event)"
     />

    <p class="text-right">
      <router-link to="/mypage">マイページへのリンク</router-link>
    </p>
  </div>
</template>

<script>
import ListItem from './ListItem'
import AreaSelector from 'components/AreaSelector'
import PageNav from 'components/PageNav'
import api from 'api'
import modal from 'util/modal'
import util from 'util/common'
export default {
  components: {
    'area-selector': AreaSelector,
    'list-item': ListItem,
    'page-nav': PageNav
  },
  created () {
    this.fetchEventList(this.$route.query)
    Object.keys(this.$route.query).forEach(k => {
      this.query[k] = this.$route.query[k]
    })
  },
  data () {
    return {
      query: {
        area: '',
        prefecture: '',
        status: 'all',
        sponsor_name: '',
        enddate_from: '',
        enddate_to: '',
        page: ''
      }
    }
  },
  methods: {
    onMoveToInput () {
      this.$store.commit('clearEventForm')
      this.$router.push('/input')
    },
    onMoveToPage (page) {
      this.query.page = page
      this.search()
    },
    search () {
      if (this.isEndDateInValid) { return }
      this.$router.push({
        path: '/list',
        query: this.parseQuery(this.query)
      })
    },
    fetchEventList (q) {
      api.fetchEventList(this, this.parseQuery(q))
      .catch(err => {
        if (err.status === 401) {
          api.onAuthRequired(this)
        } else {
          modal.showErrorModal(this, err)
        }
      })
    },
    parseQuery (query) {
      return util.removeEmptyKey({ ...query })
    },
    enableForm (form) {
      form.removeAttribute('disabled')
    },
    disableForm (form) {
      form.setAttribute('disabled', '')
    },
    switchForm (alter) {
      return (value) => {
        if (value) {
          this.disableForm(alter)
        } else {
          this.enableForm(alter)
        }
      }
    }
  },
  computed: {
    items () {
      return this.$store.state.eventList.events.filter(i => i.status !== 'notreport')
    },
    notReportedItems () {
      return this.$store.state.eventList.events.filter(i => i.status === 'notreport')
    },
    notReported () {
      return this.$store.state.eventList.not_report
    },
    canApply () {
      return !this.notReported
    },
    eventStatusText () {
      return util.lecturerStatusText
    },
    currentPage () {
      return this.$store.state.eventList.current_page
    },
    maxPage () {
      return this.$store.state.eventList.max_page
    },
    isEndDateInValid () {
      return this.query.enddate_from && this.query.enddate_to &&
      (new Date(this.query.enddate_from) > new Date(this.query.enddate_to))
    },
    isEndDateFromFormatInValid () {
      return this.query.enddate_from && !this.query.enddate_from.match(/^\d{4}\/\d{2}\/\d{2}$/)
    },
    isEndDateFromInValid () {
      return !this.isEndDateFromFormatInValid && this.query.enddate_from && !util.isDate(this.query.enddate_from)
    },
    isEndDateToFormatInValid () {
      return this.query.enddate_to && !this.query.enddate_to.match(/^\d{4}\/\d{2}\/\d{2}$/)
    },
    isEndDateToInValid () {
      return !this.isEndDateToFormatInValid && this.query.enddate_to && !util.isDate(this.query.enddate_to)
    },
    searchStyle () {
      return (this.isEndDateInValid || this.isEndDateFromFormatInValid ||
        this.isEndDateToFormatInValid || this.isEndDateFromInValid || this.isEndDateToInValid)
        ? 'disabled' : ''
    }
  },
  watch: {
    '$route': function (route) {
      this.fetchEventList(route.query)
    },
    'query.area': function (value) {
      this.switchForm(this.$refs.prefecture.$el)(value)
    },
    'query.prefecture': function (value) {
      this.switchForm(this.$refs.area.$el)(value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// EventList.vue?432b96ce